export default __webpack_public_path__ + "static/media/android_robot.50f261e9.png";